import { Avatar, Grid, IconButton, Stack, Typography } from '@mui/material';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import { styled } from '@mui/system';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
interface ProfileContainerProp {
    name?: string;
    email?: string;
    imageUrl?: string;
    navigationHandler?: () => void;
    showEditIcon?: boolean;
    disabled?: boolean;
    businessAvatar?: boolean;
}

const CameraButton = styled(IconButton)({
    top: -10,
    backgroundColor: 'white',
    borderRadius: '50%',
    boxShadow: '0px 0px 3px rgba(0,0,0,0.2)',
    padding: 4,
    height: 30,
    width: 30,
});

function ProfileContainer({ name, email, navigationHandler, imageUrl, businessAvatar, disabled }: ProfileContainerProp) {
    return (
        <Grid container spacing={1} alignItems="center" sx={{ my: 3 }}>
            {/* Left Section (Avatar) */}
            <Grid container item alignItems={'center'} spacing={1} xs={10}>
                <Stack alignItems={'center'}>
                    <Avatar src={imageUrl} sx={{ width: 74, height: 74 }}>
                        {businessAvatar && <ImageOutlinedIcon />}
                    </Avatar>
                    {disabled ? null : (
                        <CameraButton size="small" onClick={navigationHandler}>
                            <CameraAltOutlinedIcon fontSize="small" />
                        </CameraButton>
                    )}
                </Stack>
                <Grid item>
                    <div>
                        <Typography sx={{ fontSize: 16, color: '#1F2937', fontWeight: 400 }} variant="h2">
                            {name}
                        </Typography>
                        <Typography sx={{ fontSize: 14, color: '#6B7280' }} variant="body2">
                            {email}
                        </Typography>
                    </div>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default ProfileContainer;
